import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, CheckBox, DateInput, FileInput, FormField, Grid, ResponsiveContext, Text, TextArea, TextInput, Image, Button, Stack, Select } from "grommet";
import * as React from "react";
import AutoSizeTextArea from "../components/AutoSizeTextArea";
import { ImagePicker } from "../components/ImagePicker";
import StyledModal from "../components/StyledModel";
import ThemeBuilder from "../components/ThemeBuilder";
import { useReferenceData } from "../reference/ReferenceStore";
import TournamentLogoPicker from "./TournamentLogoPicker";
import TournamentSplashPicker from "./TournamentSplashPicker";
import { TournamentViewModel } from "./TournamentsStore";

const TournamentDetails = ({ tournament, isBusy, onChange }: { tournament: TournamentViewModel; isBusy: boolean; onChange: Function }) => {
    const [name, setName] = React.useState(tournament.name || "");
    const [isPublic, setIsPublic] = React.useState(tournament.isPublic || false);
    const [bracketType, setBracketType] = React.useState(tournament.bracketType || "SingleElimination");

    const [logoUri, setLogoUri] = React.useState(tournament.logoUri || "");
    const [splashUri, setSplashUri] = React.useState(tournament.splashUri || "");

    const [color, setColor] = React.useState(tournament.color || "");

    const [logoContent, setLogoContent] = React.useState("");
    const [splashContent, setSplashContent] = React.useState("");

    const bracketTypes = useReferenceData("bracketTypes");

    React.useEffect(() => {
        onChange({ name, logoUri, logoContent, splashUri, splashContent, color, isPublic, bracketType });
    }, [name, logoUri, logoContent, splashUri, splashContent, color, isPublic, bracketType]);

    const size = React.useContext(ResponsiveContext);

    React.useEffect(() => {
        if (tournament.logoUri && logoUri != tournament.logoUri) {
            setLogoUri(tournament.logoUri);
        }
        if (tournament.splashUri && splashUri != tournament.splashUri) {
            setSplashUri(tournament.splashUri);
        }
    }, [tournament.logoUri, tournament.splashUri]);

    const handleLogoChange = ({ uri, content }) => {
        if (content) {
            setLogoContent(content);
            setLogoUri("");
        } else if (uri) {
            setLogoUri(uri);
            setLogoContent("");
        }
    };

    const handleSplashChange = ({ uri, content }) => {
        if (content) {
            setSplashContent(content);
            setSplashUri("");
        } else if (uri) {
            setSplashUri(uri);
            setSplashContent("");
        }
    };

    return (
        <div>
            <>
                <Box>
                    <Grid columns={size == "small" ? ["auto"] : ["1/2", "1/2"]}>
                        <Box>
                            <FormField label="Name">
                                <TextInput value={name} onChange={(e) => setName(e.target.value)} disabled={isBusy} />
                            </FormField>
                            <FormField label="Public">
                                <CheckBox checked={isPublic} onChange={(e) => setIsPublic(e.target.checked)} disabled={isBusy} />
                            </FormField>
                            <FormField label="Bracket Type">
                                <Select
                                    value={bracketType}
                                    onChange={(e) => setBracketType(e.target.value)}
                                    labelKey="displayName"
                                    disabled={tournament.locked || isBusy}
                                    options={bracketTypes}
                                    children={(option, index, options, { active, disabled, selected }) => (
                                        <Box pad="1rem">
                                            <Text>{option.displayName}</Text>
                                        </Box>
                                    )}
                                    valueKey={{ key: "name", reduce: true }}
                                />
                            </FormField>
                        </Box>
                        <Box></Box>
                        <Box fill={true}>
                            <TournamentLogoPicker uri={logoUri} disabled={isBusy} onSelect={handleLogoChange}></TournamentLogoPicker>
                        </Box>
                        <Box fill={true}>
                            <TournamentSplashPicker uri={splashUri} disabled={isBusy} onSelect={handleSplashChange}></TournamentSplashPicker>
                        </Box>
                    </Grid>
                    <ThemeBuilder uri={logoUri} color={color} disabled={isBusy} onSelect={(color) => setColor(color)}></ThemeBuilder>
                </Box>
            </>
        </div>
    );
};

export default TournamentDetails;
